import { useGameStore } from '@/state/gameStore';
import type { GameState } from '@/state/types';

/**
 * A game is considered "active" when the player has made progress:
 * built at least one station, bought a vehicle, or generated any mission.
 * A fresh empty store with just starting credits does not count.
 */
export function hasActiveGame(state: GameState = useGameStore.getState()): boolean {
  return state.stations.length > 0 || state.vehicles.length > 0 || state.missions.length > 0;
}

export const MODE_LABELS: Record<GameState['mode'], string> = {
  normal: 'Normal',
  realistic: 'Realistisch',
  sandbox: 'Sandbox',
};
